import { checkLogin } from '@/utils/tools';

export class Pay {
  // 调用的vue实例
  root: any;
  // 商品id
  sid: string;
  // 埋点
  pageId?: string;
  // ios实例
  iosIns: any;
  // 支付初始化信息
  initInfo: {
    sid: string;
    pageId: string;
    pdt_sid: string;
  };
  constructor(root: any, sid = '395', pageId = 'dehydrationReport/index-yb') {
    this.root = root;
    this.sid = sid;
    this.pageId = pageId;
    this.iosIns = null;
    this.initInfo = {
      sid,
      pageId: this.pageId,
      pdt_sid: sid,
    };
  }
  toPay() {
    const pay = () => {
      // iOS弹窗
      if (window.getPlatform() === 'iphone') {
        this.root.$hxmpayThs.init({
          type: 'thspay',
          sid: '395',
          pageId: this.pageId,
        });
      } else {
        // 安卓弹窗
        this.root.$hxmpay.init(this.initInfo);
      }
    };
    checkLogin(pay, pay);
  }
}
